import { AxiosError } from 'axios'
import { flow } from 'mobx'

import { openPdfDocumentFromBlob } from 'Shared/utils/file'

import { STORE_UI } from 'Core/constants/stores'
import { CustomGenerator } from 'Core/interfaces/core'

import { SiteDocumentRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

import { SiteDocumentTable } from './SiteDocumentTable'

export class SiteDocumentStore {
	table: SiteDocumentTable

	constructor(private rootStore: RootStore) {
		this.table = new SiteDocumentTable(rootStore)
	}

	@flow.bound
	*downloadDocument(serviceSiteId?: Key, documentId?: Key): CustomGenerator<Blob> {
		if (!serviceSiteId || !documentId) {
			return
		}

		try {
			const document = yield SiteDocumentRepo.downloadDocument(serviceSiteId, documentId)

			openPdfDocumentFromBlob(document)
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}
}
